import { useStaticQuery, graphql } from "gatsby"

export const useLogo = () => {
  // gatsby-source-wordpress won't return the logo
  // the same image has been added to a /test page (so it will be found by gatsby) and is queried by uri
    const wordpress = useStaticQuery(graphql`query getLogo {
      wpMediaItem(title: {eq: "Dixieply"}) {
        altText
        sourceUrl
        localFile {
          childImageSharp {
            gatsbyImageData(layout: FIXED)
          }
        }
      }
    }`)

  return wordpress.wpMediaItem
}
